export default "__VITE_ASSET__CsQtS1Gy__"